import * as React from 'react';
import { Typography } from '@mui/material';

export function ArgFieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontWeight: 600, letterSpacing: '0.02em', overflowWrap: 'anywhere' }}
    >
      {children}
    </Typography>
  );
}

export function ArgFieldValue({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      variant="body2"
      sx={{ minWidth: 0, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', lineHeight: 1.55 }}
    >
      {children}
    </Typography>
  );
}
